export enum GlobalDownloadsRoutes {
  BASE = 'downloads'
}
